<template>
  <div>
    <v-app-bar style="z-index: 2;" dense fixed light color="white" class="kimsa-elevation">
      <v-img :src="require('@/assets/img/logo_header.png')" eager max-width="160" contain/>
    </v-app-bar>
    <v-sheet height="20" color="transparent"/>
  </div>
</template>

<script>
export default {
name: "DesktopToolbar"
}
</script>

<style scoped>

</style>